<template>
  <div v-if="showItem"
       class="item-standart">
    <div class="item-body">
      <div class="avatar">
        <child-avatar :child="child"
                      size="small"
                      :show-status="false" />
      </div>

      <div class="content">
        <div class="description">
          {{ title }}
        </div>

        <a :href="item.details.param"
           class="one-liner request-link"
           target="_blank">
          {{ urlTitle }}
        </a>

        <feed-item-details class="details"
                           :item="itemWithDevice"
                           :show-name="false"
                           :show-device="false"/>
      </div>
    </div>

    <div class="divider"></div>

    <div class="item-footer" @click="openManageRequestsPage">
      {{ $t("feed.items.requestItemRedirect") }}

      <div class="dropdown-option-arrow"></div>
    </div>
  </div>
</template>

<script>
  import ItemBase from './ItemBase.vue'
  import { buttonText } from '@/constants/requests'
  import { getDomain } from '@/services/utils.js'

  export default {
    extends: ItemBase,

    props: {
      item: {
        required: true,
        type: Object
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
        getPrimaryDevice: 'getPrimaryDevice'
      }),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      groupId() {
        return this.currentUser.group_id
      },

      showItem() {
        return this.child
      },

      child() {
        return this.getChildById(this.item.user_id)
      },

      primaryDevice() {
        return this.getPrimaryDevice(this.child.id)
      },

      title() {
        return `${this.item.user.name} ${this.$t("childRequests.hasRequestedAccessTo")}`
      },

      buttonText() {
        return `${buttonText[this.item.details.type]}`
      },

      itemWithDevice() {
        return {
          ...this.item,
          device: this.primaryDevice ? this.primaryDevice : null
        }
      },

      urlTitle() {
        return getDomain(this.item.details.param)
      }
    },

    methods: {
      ignore() {
        this.showModal('requestAction', {
          request: {
            ...this.item,
            ...this.item.details,
            id: this.item.details.request_id
          },
          action: 'ignore'
        })
      },

      grant() {
        this.showModal('requestAction', {
          request: {
            ...this.item,
            ...this.item.details,
            id: this.item.details.request_id
          },
          action: 'grant'
        })
      },

      openManageRequestsPage() {
        this.$router.push({
          name: 'manageRequests'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item-standart {
    display: flex;
    flex-direction: column;
    .item-body {
      width: 100%;
      display: flex;

      .content {
        display: flex;
        flex-direction: column;

        .details {
          width: 100%;
          height: auto;
        }

        .request-link {
          margin-top: 4px;
        }
      }
    }

    .divider {
      height: 1px;
      width: 100%;

      margin-top: 8px;
      background: #9E9E9E;
      opacity: .1;
    }

    .item-footer {
      height: 34px;
      width: 100%;
      padding-right: 5px;

      color: #3b3b3b;
      cursor: pointer;

      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .dropdown-option-arrow {
        width: 13px;
        height: 13px;

        position: relative;
        top: -3px;

        border-bottom: 1px solid #b9b9b9;
        border-right: 1px solid #b9b9b9;
        transform: rotate(-45deg);
      }
    }
  }
</style>